import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      height: '100vh',
    },
    modal: {
      background: theme.palette.secondary.main,
      borderRadius: 5,
      maxWidth: 590,
      padding: '32px 24px',
      textAlign: 'center',
    },
    modalCloseBtn: {
      display: 'block',
      cursor: 'pointer',
      height: 14,
      marginBottom: SMALL_MARGIN,
      marginLeft: 'auto',
      width: 14,
    },
    modalDescription: {
      color: colorsPalette.gray,
      margin: '24px 0 50px',
    },
    controls: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& > a': {
        marginBottom: 9,
      },
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        justifyContent: 'center',
        '& > a': {
          marginBottom: 0,
          marginRight: SMALL_MARGIN,
        },
      },
    },
  }),
);

export default useStyles;
